var React = require('react');

function PatternCirclesGreen (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"315","cy":"315","r":"314","stroke":"#9FD833","strokeWidth":"2","strokeDasharray":"22 22","key":0}),React.createElement("circle",{"cx":"314.459","cy":"314.459","r":"251.758","stroke":"#9FD833","strokeWidth":"2","strokeDasharray":"22 22","key":1}),React.createElement("circle",{"cx":"315","cy":"315","r":"173.278","stroke":"#9FD833","strokeWidth":"2","strokeDasharray":"22 22","key":2})]);
}

PatternCirclesGreen.defaultProps = {"width":"630","height":"630","viewBox":"0 0 630 630","fill":"none"};

module.exports = PatternCirclesGreen;

PatternCirclesGreen.default = PatternCirclesGreen;
